export function friendlyCorpError(err: string | undefined): string {
  switch (err) {
    case 'name_taken': return 'That corporation name is taken.';
    case 'tag_taken': return 'That tag is taken.';
    case 'manager_taken': return 'That pilot already manages a corporation.';
    case 'percentages_must_sum_100': return 'Owner percentages must sum to 100%.';
    case 'manager_must_be_owner': return 'The manager must be one of the owners.';
    case 'founder_must_be_owner': return 'You must be one of the owners.';
    case 'insufficient_bank': return 'The corp bank does not have that much.';
    case 'no_permission': return 'You do not have permission to do that.';
    case 'cannot_change_manager': return "You can't change the manager's permissions.";
    case 'unknown_player': return 'No pilot found with that name (names are case-sensitive).';
    case 'not_manager': return 'Only the manager can do that.';
    case 'must_be_docked': return 'You must be docked at a station for that.';
    case 'owns_stations': return 'The corp still owns one or more stations. Transfer or decommission them first.';
    case 'owns_structures': return 'The corp still owns planet structures. Transfer or dismantle them first.';
    case 'active_vote': return 'There is an active manager-removal vote. Wait for it to resolve.';
    case 'bank_not_empty': return 'The corp bank still has credits. Withdraw them first.';
    default: return err ?? 'Action failed.';
  }
}
